
type StringJSON = {[key: string]: string};

export const formToJson = (form: JQuery<HTMLFormElement>): StringJSON =>
    form.serializeArray()
        .reduce((json: StringJSON, {name, value}) => {
            json[name] = value;
            return json;
        }, {});